import 'cross-fetch/polyfill';
import ApolloClient from 'apollo-boost';

// vueApolloは使わずに利用
export function createApollo(graphqlUrl = null) {
    let url;

    if (graphqlUrl) {
        url = graphqlUrl;
    } else {
        url = process.env.MIX_GRAPHQL_URI + 'graphql';
    }

    const client = new ApolloClient({
        uri: url,
        request: operation => {
            const token = localStorage.getItem("web-token");
            operation.setContext({
                headers: {
                    authorization: token ? `Bearer ${token}` : ""
                }
            });
        }
    });

    return client;
}
